.page {
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  animation: fade-up 0.55s var(--kh-ease-out) both;
}

.header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.headerTitle {
  font-family: var(--kh-font-mono);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  color: #ffffff;
  text-transform: uppercase;
  flex-shrink: 0;
  margin: 0;
}

.headerLine {
  flex: 1;
  height: 0.5px;
  background: rgba(255, 255, 255, 0.2);
}

.headerActions {
  display: flex;
  gap: var(--kh-space-2);
  flex-shrink: 0;
}

.btnPrimary,
.btnSecondary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.18);
  border: 0.5px solid rgba(255, 255, 255, 0.4);
  border-radius: 20px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background var(--kh-duration-fast),
    border-color var(--kh-duration-fast);
}

.btnPrimary:hover,
.btnSecondary:hover {
  background: rgba(255, 255, 255, 0.28);
  border-color: rgba(255, 255, 255, 0.6);
}

/* Category filter bar */
.categoryBar {
  display: flex;
  flex-wrap: wrap;
  gap: var(--kh-space-2);
  align-items: center;
}

.categoryPill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  background: rgba(255, 255, 255, 0.12);
  border: 0.5px solid rgba(255, 255, 255, 0.3);
  border-radius: 100px;
  font-size: var(--kh-size-meta);
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition:
    background var(--kh-duration-fast),
    border-color var(--kh-duration-fast),
    color var(--kh-duration-fast);
}

.categoryPill:hover {
  background: rgba(255, 255, 255, 0.22);
  border-color: rgba(255, 255, 255, 0.5);
  color: #fff;
}

.categoryPillActive {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.6);
  color: #fff;
  font-weight: var(--kh-font-label);
}

.categoryPillEditBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.55;
  transition: opacity var(--kh-duration-fast);
  line-height: 1;
}

.categoryPillEditBtn:hover {
  opacity: 1;
}

/* Card wrapper */
.card {
  background: var(--kh-surface);
  border: 0.5px solid var(--kh-border);
  border-radius: var(--kh-radius-card);
  box-shadow: var(--kh-shadow-1);
  overflow: hidden;
}

/* Table */
.table {
  width: 100%;
  border-collapse: collapse;
}

.tableHead {
  background: var(--kh-surface-2);
}

.tableHead th {
  padding: 10px var(--kh-space-4);
  text-align: left;
  font-size: var(--kh-size-label);
  font-weight: var(--kh-font-label);
  letter-spacing: var(--kh-ls-label);
  text-transform: uppercase;
  color: var(--kh-text-muted);
  border-bottom: 1px solid var(--kh-border);
}

.tableRow {
  border-bottom: 1px solid var(--kh-border);
}

.tableRow:last-child {
  border-bottom: none;
}

.tableRow td {
  padding: 12px var(--kh-space-4);
  vertical-align: top;
}

.promptTitle {
  font-size: var(--kh-size-body);
  font-weight: var(--kh-font-label);
  color: var(--kh-text-primary);
  margin: 0 0 2px;
}

.promptDesc {
  font-size: var(--kh-size-meta);
  color: var(--kh-text-muted);
  margin: 0;
  line-height: 1.4;
}

.promptTemplate {
  font-size: var(--kh-size-meta);
  color: var(--kh-text-secondary);
  font-family: var(--kh-font-mono);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
  display: block;
}

.promptCategory {
  display: inline-block;
  padding: 3px 8px;
  background: var(--kh-red-dim);
  color: var(--kh-red);
  border-radius: var(--kh-radius-badge);
  font-size: var(--kh-size-meta);
  font-weight: var(--kh-font-label);
  white-space: nowrap;
}

.actionsCell {
  display: flex;
  gap: var(--kh-space-1);
  justify-content: flex-end;
}

.actionBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 1px solid var(--kh-border);
  border-radius: var(--kh-radius-sm);
  color: var(--kh-text-secondary);
  cursor: pointer;
  transition:
    border-color var(--kh-duration-fast),
    color var(--kh-duration-fast);
}

.actionBtn:hover {
  border-color: var(--kh-border-hover);
  color: var(--kh-text-primary);
}

.actionBtnDanger:hover {
  border-color: var(--kh-red-border);
  color: var(--kh-red);
}

/* Empty state */
.empty {
  text-align: center;
  padding: 28px 20px;
  color: rgba(255, 255, 255, 0.65);
  font-size: var(--kh-size-body);
  margin: 0;
}

/* Modal */
.modalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: var(--kh-space-6);
}

.modal {
  background: var(--kh-surface);
  border-radius: var(--kh-radius-card);
  box-shadow: var(--kh-shadow-modal);
  padding: var(--kh-space-6);
  width: 100%;
  max-width: 520px;
}

.modalTitle {
  font-size: 18px;
  font-weight: var(--kh-font-heading);
  color: var(--kh-text-primary);
  margin: 0 0 var(--kh-space-5);
}

.formField {
  margin-bottom: var(--kh-space-4);
}

.formLabel {
  display: block;
  font-size: var(--kh-size-meta);
  font-weight: var(--kh-font-label);
  color: var(--kh-text-secondary);
  margin-bottom: var(--kh-space-1);
}

.formInput,
.formTextarea,
.formSelect {
  width: 100%;
  padding: 8px var(--kh-space-3);
  background: var(--kh-surface);
  border: 1px solid var(--kh-border-hover);
  border-radius: var(--kh-radius-sm);
  font-size: var(--kh-size-body);
  font-family: var(--kh-font);
  color: var(--kh-text-primary);
  box-sizing: border-box;
  transition: border-color var(--kh-duration-fast);
}

.formInput:focus,
.formTextarea:focus,
.formSelect:focus {
  outline: none;
  border-color: var(--kh-red);
}

.formTextarea {
  resize: vertical;
  min-height: 120px;
  font-family: var(--kh-font-mono);
  font-size: var(--kh-size-meta);
  line-height: 1.5;
}

.formHint {
  display: block;
  font-size: var(--kh-size-meta);
  color: var(--kh-text-muted);
  margin-top: var(--kh-space-1);
}

.formError {
  font-size: var(--kh-size-meta);
  color: var(--kh-red);
  margin-bottom: var(--kh-space-3);
}

.modalActions {
  display: flex;
  gap: var(--kh-space-2);
  justify-content: flex-end;
  margin-top: var(--kh-space-5);
}

.modalActions .btnPrimary {
  background: var(--kh-red);
  border: none;
  border-radius: var(--kh-radius-sm);
  color: #fff;
}

.modalActions .btnPrimary:hover {
  background: var(--kh-red-dark);
}

.modalActions .btnSecondary {
  background: transparent;
  border: 1px solid var(--kh-border-hover);
  border-radius: var(--kh-radius-sm);
  color: var(--kh-text-primary);
}

.modalActions .btnSecondary:hover {
  border-color: var(--kh-red-border);
}

@keyframes fade-up {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
